import { Box, Button, Dialog, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: '#FAFCFF',
    minWidth: '640px',
  },
}));

export const DialogContent = styled(Box)(() => ({
  padding: '56px 45px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '16px',
}));

export const DialogTitle = styled(Typography)(() => ({
  fontSize: '24px',
  fontWeight: 500,
}));

export const DialogSubtitle = styled(Typography)(() => ({
  fontSize: '18px',
  color: '#595959',
  textAlign: 'center',
}));

export const DialogActions = styled(Box)(() => ({
  display: 'flex',
  gap: 40,
  justifyContent: 'flex-end',
  marginTop: 24,
}));

export const RemoveButton = styled(Button)(() => ({
  borderRadius: '30px',
  fontWeight: 600,
  width: 220,
  padding: '12px, 24px',
  height: '56px',
  backgroundColor: '#FF4C4C',
  color: '#FAFCFF',
  '&:hover': {
    backgroundColor: '#FF4C4C',
    filter: 'brightness(85%)',
  },
}));
